import { jsx as _jsx } from "react/jsx-runtime";
import styles from './PreviewElements.module.scss';
import { useCurrentTheme } from '../../../../../../hooks/useCurrentTheme';
var PreviewGradientLine = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'range' : _b;
    var theme = useCurrentTheme();
    var min = theme.matrix.range.minRange;
    var mid = '';
    var max = theme.matrix.range.maxRange;
    if (title === 'ev') {
        min = theme.matrix.ev.negEV;
        mid = theme.matrix.ev.zeroEV;
        max = theme.matrix.ev.posEV;
    }
    if (title === 'equity') {
        min = theme.matrix.equity.minEquity;
        mid = theme.matrix.equity.midEquity;
        max = theme.matrix.equity.maxEquity;
    }
    if (title === 'eqr') {
        min = theme.matrix.eqr.minEqr;
        mid = theme.matrix.eqr.midEqr;
        max = theme.matrix.eqr.maxEqr;
    }
    var gradient = title !== 'range'
        ? "linear-gradient(to right, ".concat(min, ", ").concat(mid, ", ").concat(max, ")")
        : "linear-gradient(to right, ".concat(min, ", ").concat(max, ")");
    return (_jsx("div", { className: styles.gradientLinePreview, style: {
            backgroundImage: gradient,
        } }));
};
export default PreviewGradientLine;
